/**
 * Root reducer.
 * @module reducers/root
 */

import { personaAfferenzaReducer } from './personaAfferenzaReducer';
import { schedaPersonaEsistenteViewletReducer } from './schedaPersonaEsistenteViewletReducer';
import { personaQRCodeReducer } from './personaQRCodeReducer';
import { personaGenereReducer } from './personaGenereReducer';
import { searchSchedaPersonaReducer } from './searchSchedaPersonaReducer';
import { organigrammaReducer } from './organigrammaReducer';
import { personaOggReducer } from './personaOggReducer';
import { ripristinaDefaultsReducer } from './ripristinaDefaultsReducer';
import { sincronizzaAliasReducer } from './sincronizzaAliasReducer';
import { fixaNascostiReducer } from './fixaNascostiReducer';

/**
 * Root reducer.
 * @function
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
const reducers = {
    personaAfferenzaReducer: personaAfferenzaReducer,
    schedaPersonaEsistenteViewletReducer: schedaPersonaEsistenteViewletReducer,
    personaQRCodeReducer: personaQRCodeReducer,
    personaGenereReducer: personaGenereReducer,
    searchSchedaPersonaReducer: searchSchedaPersonaReducer,
    organigrammaReducer: organigrammaReducer,
    personaOggReducer:personaOggReducer,
    ripristinaDefaultsReducer: ripristinaDefaultsReducer,
    sincronizzaAliasReducer: sincronizzaAliasReducer,
    fixaNascostiReducer: fixaNascostiReducer,
};

export default reducers;
